<div class="feature-list-item-container" *ngIf="feature" (click)="featureClicked($event)">
  <div class="label">
    <div class="sign" *ngFor="let label of featureDetail.productLabels">{{ label.localizedLabel }}</div>
  </div>
  <div class="content">
    <div class="wrapper">
      <div class="header">
        <div class="icon">
          <img
            src="./assets/features/{{featureDetail.productLogo.toLowerCase()}}_feature.svg"
            alt="feature_icon_{{featureDetail.productLogo.toLowerCase()}}"
            title="feature_icon_{{featureDetail.productLogo.toLowerCase()}}" />
        </div>
        <div class="description">
          <div class="title"> {{ featureDetail.name }} </div>
          <div class="pricing">
            <div class="status {{ hideStatus ? 'hidden' : '' }}">
              <div class="success" [hidden]="status !== 'success'">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                  <path fill="#35CD05" fill-rule="evenodd" d="M14.843 18.711L3.689 7.847 10.622 0.914 12.914 3.117 8.102 7.847 16.965 16.507z" transform="rotate(-90 10.327 9.812)"/>
                </svg>
              </div>
              <div class="error" [hidden]="status !== 'error'">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                  <path fill="red" fill-rule="evenodd" d="M17.071 4.95l-5.05 5.049 5.05 5.052-2.02 2.02-5.052-5.051-5.05 5.051-2.02-2.02 5.05-5.052-5.05-5.05 2.02-2.02L10 7.979l5.05-5.05 2.021 2.02z"/>
                </svg>
              </div>
              {{ 'feature.status.' + featureStatus | translate }}
            </div>
            <div class="price" [hidden]="hidePrice" *ngIf="featureDetail.price.value !== 0; else freeVersion">{{ featureDetail.price.formattedValue }}</div>
            <ng-template #freeVersion>
              <div class="price free" [hidden]="hidePrice">{{ 'feature.price.label.free' | translate }}</div>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="description">
        <markdown [data]="featureDetail.summary"></markdown>
      </div>
    </div>
    <div class="actions">
      <div class="btn-details">
        <kion-button [title]="'feature.card.button.detail' | translate" (clicked)="detailsButtonClicked($event)"></kion-button>
      </div>
      <div class="btn-add-to-card" [hidden]="hideAddToBasket || !canSeeAddToBasket">
        <kion-button [title]="'feature.card.button.addToCard' | translate" mode="primary" [isLoading]="isAddingToBasket" [disabled]="status === 'error'" (clicked)="addToCartClicked($event)"></kion-button>
      </div>
      <div class="btn-add-to-card" *ngIf="isInstalled && isTruckHealthManagement && device.truckHealthManagementLink">
        <kion-button [title]="'feature.card.button.openThm' | translate" mode="linked-application" [isLink]="true" [link]="{external: 'true', url: device.truckHealthManagementLink, target: 'true'}" [isLoading]="isAddingToBasket" ></kion-button>
      </div>
    </div>
  </div>
</div>

<ng-template #detailModal let-c="close" let-d="dismiss">
  <div class="modal-body">
    <div class="header">
      <div class="close-btn" (click)="d()">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21">
          <path fill="#444" fill-rule="evenodd" d="M17.857 5.714L3.153 5.714 7.648 1.219 6.638 0.209 0.419 6.429 6.638 12.648 7.648 11.638 3.153 7.143 17.857 7.143z" transform="translate(.714 4.071)"/>
        </svg>
      </div>
      <div class="headline">
        {{ device.id }}
      </div>
    </div>
    <div class="sticky">
      <div class="sticky-bar"></div>
    </div>
    <div class="content">
      <div class="article-number" *ngIf="feature">
        {{ 'feature.articleNumber.headline' | translate }} {{ feature.code }}
      </div>
      <div class="feature-header">
        <div class="icon" *ngIf="featureDetail as product">
          <img
            src="./assets/features/{{product.productLogo.toLowerCase()}}_feature.svg"
            alt="feature_icon_{{product.productLogo.toLowerCase()}}"
            title="feature_icon_{{product.productLogo.toLowerCase()}}" />
        </div>
        <div class="text">
          <div class="title">{{ featureDetail.name }}</div>
          <div class="price-bar">
            <div class="status {{ hideStatus ? 'hidden' : '' }}">
              <div class="success" [hidden]="status !== 'success'">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                  <path fill="#35CD05" fill-rule="evenodd" d="M14.843 18.711L3.689 7.847 10.622 0.914 12.914 3.117 8.102 7.847 16.965 16.507z" transform="rotate(-90 10.327 9.812)"/>
                </svg>
              </div>
              <div class="error" [hidden]="status !== 'error'">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                  <path fill="red" fill-rule="evenodd" d="M17.071 4.95l-5.05 5.049 5.05 5.052-2.02 2.02-5.052-5.051-5.05 5.051-2.02-2.02 5.05-5.052-5.05-5.05 2.02-2.02L10 7.979l5.05-5.05 2.021 2.02z"/>
                </svg>
              </div>
              {{ 'feature.status.' + featureStatus | translate }}
            </div>
            <div class="price" [hidden]="hidePrice" *ngIf="featureDetail.price.value !== 0; else freeVersion">{{ featureDetail.price.formattedValue }}</div>
            <ng-template #freeVersion>
              <div class="price free" [hidden]="hidePrice">{{ 'feature.price.label.free' | translate }}</div>
            </ng-template>
          </div>
        </div>
        <div class="btn-add-to-card" [hidden]="hideAddToBasket || !canSeeAddToBasket">
          <kion-button [title]="'feature.card.button.addToCard' | translate" mode="primary" [isLoading]="isAddingToBasket" [disabled]="status === 'error'" (clicked)="addToCartClicked($event)"></kion-button>
        </div>
        <div class="btn-add-to-card" *ngIf="isInstalled && isTruckHealthManagement && device.truckHealthManagementLink">
          <kion-button [title]="'feature.card.button.openThm' | translate" mode="linked-application" [isLink]="true" [link]="{external: 'true', url: device.truckHealthManagementLink, target: 'true'}" [isLoading]="isAddingToBasket" ></kion-button>
        </div>
      </div>
      <div class="description">
        <div class="section">
          <markdown [data]="featureDetail.summary"></markdown>
        </div>
        <ng-container *ngIf="feature.salesRule as sale">
          <div class="section instruction" *ngIf="sale.instruction && !isInstalled">
            <markdown [data]="sale.instruction"></markdown>
          </div>
        </ng-container>
        <div class="section" *ngIf="featureDetail.usps">
          <div class="headline">{{ 'feature.modal.benefits.headline'| translate }}</div>
          <markdown [data]="featureDetail.usps"></markdown>
        </div>
        <div class="section" *ngIf="featureDetail.description">
          <div class="headline">{{ 'feature.modal.functions.headline'| translate }}</div>
          <markdown [data]="featureDetail.description"></markdown>
        </div>
        <div class="section" *ngIf="featureDetail.operatingElement">
          <div class="headline">{{ 'feature.modal.operatingElements.headline'| translate }}</div>
          <markdown [data]="featureDetail.operatingElement"></markdown>
        </div>
      </div>
      <kion-image-carousel
        *ngIf="images$ | async as images"
        [items]="images"
        [showNavigationOnlyDesktop]="true"
      ></kion-image-carousel>
    </div>
  </div>
</ng-template>
